// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;O let the nations rejoice and be glad,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for you will judge the peoples righteously<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and govern the nations upon earth.<br> </p> </div></div>";
// Exports
module.exports = code;